import React from "react";
import { Form, Select } from "antd";
import employeesConnect from "../../../../common/hoc/employeesConnect";
const { Option } = Select;

const Dispatcher = ({ form, disabled, profiles }) => {
  const { getFieldDecorator } = form;
  return (
    <div className="offer-card__item">
      <span className="label">Ответственный:</span>
      <Form.Item>
        {getFieldDecorator("dispatcher", {
          rules: [
            {
              required: true,
              message: "Поле, обязательное для заполнения"
            }
          ]
        })(
          <Select
            style={{ width: 368 }}
            allowClear={true}
            showSearch
            getPopupContainer={trigger => trigger.parentNode}
            filterOption={(input, option) =>
              option.props.children[0]
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            placeholder="Укажите ответственного диспетчера"
            disabled={disabled}
          >
            {profiles &&
              profiles.map(item =>
                item.roleKey !== "driver" ? (
                  <Option key={item.profileId} value={item.profileId}>
                    {item.userName} {item.role ? `(${item.role})` : ""}
                  </Option>
                ) : null
              )}
          </Select>
        )}
      </Form.Item>
    </div>
  );
};

// export default employeesConnect(Dispatcher, ['dispatcher']);
export default employeesConnect(Dispatcher); // todo отображаем пока все профиля
